import { FavritApp } from '../../generated-api'

export const mapFavritAppToName = (favritApp: FavritApp): string => {
    switch (favritApp) {
        case FavritApp.ADMIN_APP:
            return 'Admin App'
        case FavritApp.EPOS_APP_DIRECT_SALE:
            return 'ePOS App Direct Sale'
        case FavritApp.EPOS_APP_OPEN_BILL:
            return 'ePOS App Open Bill'
        case FavritApp.UNIBILL_APP:
            return 'Unibill App'
        case FavritApp.GUEST_APP:
            return 'Guest App'
        case FavritApp.SUBSIDY:
            return 'Subsidy'
    }
}
